import Swal from "sweetalert2";

interface Props {
    title: string,
    message: string,
    type: "success" | "error" | "warning" | "info" | "question"
}

export const AlertPersonalizate = ({ title, message, type }: Props) => {

    Swal.fire({
        title: `${title}`,
        text: `${message}`,
        icon: `${type}`
    });

}